import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", city: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Received. I'll reach out privately.");
      setForm({ name: "", email: "", city: "", message: "" });
    } catch { toast.error("Something went wrong. Try again."); }
    finally { setSending(false); }
  };

  return (
    <div data-testid="contact-page" className="font-body">
      <section className="pt-32 pb-10 sm:pt-40 sm:pb-14">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <span className="rc-eyebrow">Private Conversation</span>
          <h1 className="font-display text-4xl sm:text-6xl font-semibold mt-5" style={{ letterSpacing: "-0.03em", lineHeight: "1.05" }}>
            Start the <span className="text-[#2d7cf6]">conversation.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[color:var(--rc-text-muted)] max-w-xl leading-relaxed">
            Direct, encouraging, private. Reply within 24–48 hours from a neutral inbox.
          </p>
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-16">
        <form onSubmit={submit} data-testid="contact-form" className="max-w-xl mx-auto px-6 md:px-10 space-y-5">
          <div>
            <label htmlFor="contact-name" className="block mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)]">Alias or first name</label>
            <input id="contact-name" data-testid="contact-name" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-4 py-3" placeholder="Marcus" />
          </div>
          <div>
            <label htmlFor="contact-email" className="block mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)]">Email</label>
            <input id="contact-email" data-testid="contact-email" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full px-4 py-3" placeholder="you@somewhere.com" />
          </div>
          <div>
            <label htmlFor="contact-city" className="block mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)]">City you'd meet in (optional)</label>
            <input id="contact-city" data-testid="contact-city" value={form.city} onChange={e => setForm({...form, city: e.target.value})} className="w-full px-4 py-3" placeholder="Las Vegas" />
          </div>
          <div>
            <label htmlFor="contact-message" className="block mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-[color:var(--rc-text-muted)]">What are you looking to work on?</label>
            <textarea id="contact-message" data-testid="contact-message" required rows={6} value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full px-4 py-3" placeholder="A sentence or two is plenty." />
          </div>
          <button data-testid="contact-submit" type="submit" disabled={sending} className="rc-btn rc-btn-blue w-full disabled:opacity-50">
            {sending ? "Sending…" : <>Send Message <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>
      </section>
    </div>
  );
}
